<template>
  <div>
    <v-slider
      step=".01"
      min="0"
      max="2"
      ref="opacitySlider"
      @change="updateUrl"
      :disabled="sliderDisabled"
      v-model="opacity.value"
    >
      <template v-slot:prepend>
        <v-icon
          :color="A_Color"
          :disabled="$store.getters.getSideADisplayName.length === 0"
          >mdi-map</v-icon
        >
      </template>
      <template v-slot:append>
        <v-icon
          :color="B_Color"
          :disabled="$store.getters.getSideBDisplayName.length === 0"
          >mdi-map</v-icon
        >
      </template>
    </v-slider>
    <div class="subtitle-container">
      <div class="subtitle font-weight-bold" v-bind:style="{ color: A_Color }">
        {{ $store.getters.getSideADisplayName }}
      </div>
      <div
        class="subtitle right font-weight-bold"
        v-bind:style="{ color: B_Color }"
      >
        {{ $store.getters.getSideBDisplayName }}
      </div>
    </div>
  </div>
</template>

<script>
import { EventBus } from "../../js/DataManagement/EventBus";

export default {
  name: "SideOpacitySlider",
  data: function () {
    return { opacity: { value: 2 } };
  },
  
  mounted: function () {
    let self = this;
    if (this.$querystringManager.route.query.opacity) {
      let val = this.$querystringManager.route.query.opacity;
      this.$nextTick(() => {
        self.$map.once("idle", () => {
          self.$set(self.opacity, "value", val);
        });
      });
    }
    EventBus.$on('mainOpacitySet',(val)=>{
      if(this.opacity.value !== val) this.opacity.value = val;
    })
  },
  methods: {
    updateUrl(val) {
      this.$querystringManager.addQueryParam("opacity", val.toString());
    },
  },
  computed: {
    sliderDisabled: function () {
      return (
        this.$store.getters.getSideBid.length === 0 ||
        this.$store.getters.getSideAid.length === 0
      );
    },
    A_Color: function () {
      const id = this.$store.getters.getSideAid;
      const _colorVal = this.$pgConfig.filter((p) => id === p.tablename);

      let _color = "#888";
      if (_colorVal.length > 0) {
        _color = `#${_colorVal[0].mapcolor}`;
      }

      return _color;
      //return this.$styleConfig.styles.outlines.paint["Prop-A"]["line-color"];
    },
    B_Color: function () {
      const id = this.$store.getters.getSideBid;
      const _colorVal = this.$pgConfig.filter((p) => id === p.tablename);

      let _color = "#888";
      if (_colorVal.length > 0) {
        _color = `#${_colorVal[0].mapcolor}`;
      }

      return _color;
      //return this.$styleConfig.styles.outlines.paint["Prop-B"]["line-color"];
    },
  },
  watch: {
    "opacity.value": function () {
       
      let self = this;
      EventBus.$emit("sideOpacitySet", self.opacity.value);
    },
  },
};
</script>

<style lang="scss" scoped>
.subtitle{
  max-width: 7rem;
}
</style>